import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SlideshowService } from "../../../slideshow/slideshow.service";
import { MlResult, MlSlide } from "../../ml-result.model";
import { MlGeneration } from "./MlGeneration.service";

@Component({
    selector: "generate-status-dialog",
    templateUrl: "generate-status-dialog.component.html",
    styleUrls: ["./generate-status-dialog.component.css"],
    providers: [MlGeneration],
})
export class GenerateStatusDialog {
    result: MlResult;
    slideshow;
    status = "Generating...";

    constructor(
        public dialogRef: MatDialogRef<GenerateStatusDialog>,
        @Inject(MAT_DIALOG_DATA)
        public data: { prompt: string; slideshow: SlideshowService },
        public mlGen: MlGeneration
    ) {
        this.result = {
            title: "",
            slides: [],
            prompt: data.prompt,
            status: {
                done: false,
                cancel: false,
                retry: false,
                error: false,
                okayToInsert: false,
            },
        };
        this.slideshow = data.slideshow;
        this.getAiArticle(data.prompt).then(
            () => {
                this.result.status.done = true;
                this.status = "Done!";
            },
            (error) => {
                console.error(error);
                this.result.status.error = true;
                this.status = "Error";
            }
        );
    }

    async getAiArticle(prompt: string) {
        const examples = await this.mlGen.getExamples(prompt, this.slideshow);
        const headers = [];
        let headerIndex = 1;

        for (const example of examples) {
            const header = await this.mlGen.getHeader(
                prompt,
                example,
                headerIndex
            );

            headerIndex++;
            headers.push(header);

            if (this.result.status.cancel) {
                return;
            }
        }

        const examplesWithHeaders = examples.map((example, index) => {
            return {
                header: headers[index],
                topic: example,
            };
        });

        const title = await this.mlGen.getTitle(prompt);
        this.result.title = title;

        this.result.status.okayToInsert = true;

        if (this.result.status.cancel) {
            return;
        }

        if (this.slideshow.assignment.intro) {
            const intro = await this.mlGen.getIntro(prompt, this.slideshow);
            this.result.intro = intro;

            if (this.result.status.cancel) {
                return;
            }
        }

        let slideIndex = 1;
        for (const example of examplesWithHeaders) {
            const slide: MlSlide = {
                header: example.header,
                content: [],
                topic: example.topic,
            };

            const content = await this.mlGen.getContent(
                prompt,
                example.topic,
                example.header,
                slideIndex,
                this.slideshow
            );
            slideIndex++;
            slide.content = content;

            this.result.slides.push(slide);

            if (this.result.status.cancel) {
                return;
            }
        }
    }

    onNoClick(): void {
        this.result.status.cancel = true;
        this.dialogRef.close(this.result);
    }

    onRetry(): void {
        this.result.status.retry = true;
        this.dialogRef.close(this.result);
    }
}
